import type { ComponentType } from "react";
import DailySpinBanner from "../DailySpinBanner";
import SubscriptionBanner from "./SubscriptionBanner";
import TokensBanner from "./TokensBanner";
import UnderageVerificationBanner from "./UnderageVerificationBanner";
import WebcamBanner from "./WebcamBanner";
import WebcamBannerNative from "./WebcamBannerNative";

export type AdsBannerVariant =
  | "dailyspin"
  | "tokens"
  | "subscription"
  | "webcam"
  | "webcam_native"
  | "underage_verification";

export type AdsBannerConfig = {
  id: AdsBannerVariant;
  Component: ComponentType;
  slot?: string;
  bannedFromPages?: string[];
  allowedPages?: string[];
  weight?: number;
  pagePriorities?: Record<string, number>;
  isAvailable?: (params: {
    user: any;
    pathname: string;
  }) => boolean;
};

export const ADS_BANNERS: AdsBannerConfig[] = [
  {
    id: "underage_verification",
    Component: UnderageVerificationBanner,
    pagePriorities: {
      "*": 40,
    },
    isAvailable: ({ user }) => user?.informations?.verified_age !== true,
  },
  {
    id: "dailyspin",
    Component: DailySpinBanner,
    pagePriorities: {
      "*": 30,
    },
    isAvailable: ({ user }) =>
      Boolean(user?.informations) &&
      user?.informations?.type !== "guest" &&
      Boolean(user?.informations?.is_email_confirmed) &&
      user?.informations?.can_play_dailyspin !== false,
  },
  {
    id: "tokens",
    Component: TokensBanner,
    pagePriorities: {
      "*": 20,
    },
  },
  {
    id: "subscription",
    Component: SubscriptionBanner,
    pagePriorities: {
      "*": 20,
    },
    isAvailable: ({ user }) => {
      const gender = user?.informations?.gender;
      return gender !== "woman" && gender !== "couple";
    },
  },
  {
    id: "webcam_native",
    Component: WebcamBannerNative,
    pagePriorities: {
      "*": 20,
    },
  },
];

export const DEACTIVATED_ADS_BANNERS: AdsBannerConfig[] = [
  {
    id: "webcam",
    Component: WebcamBanner,
  },
];
